import ProfileDetailActions from "pages/Profile/ProfileDetailActions";
import "pages/Profile/ProfileDetail.scss";
import ProfilePic from "assets/images/default-avatar.png";
import Labels from "components/ui/Labels/Labels";
import Trans from "features/translation/components/Trans";
import ResponsiveImage from "components/ui/ResponsiveImage/ResponsiveImage";
import HTMLContainer from "components/ui/HTML/HTMLContainer";

function ProfileDetail({ data, isOwnProfile = false }) {
  const infoLabels = [];
  if (data.field_profile_hide_profile?.value === '1' && !isOwnProfile) {
    return <h1 className={ 'text-white' }><Trans text='Dit profiel is verborgen door het lid'/></h1>;
  }

  if (data.field_profile_hide_profile?.value === '1') {
    infoLabels.push('Onzichtbaar');
  } else {
    if (data.field_profile_hide_gender.value !== '1') {
      data.field_profile_gender.value && infoLabels.push(data.field_profile_gender.value);
    }

    data.field_profile_city.value && infoLabels.push(data.field_profile_city.value);

    if (data.field_profile_age.value && data.field_profile_hide_age.value !== '1') {
      data.field_profile_age.value && infoLabels.push(`${ data.field_profile_age.value } jaar`);
    }

    if (data.field_profile_hide_volunteer?.value !== '1' && data.field_profile_is_volunteer.value === '1') {
      infoLabels.push('ANBO-PCOB vrijwilliger');
    }
  }

  const interestLabels = data.field_interests && data.field_interests.map(item => item.name.value);

  return (
    <>
      <div className={ 'profile-detail' }>
        <div className={ 'profile-detail__header' }>
          <div className={ 'profile-detail__avatar' }>
            { data.field_profile_photo.value ? <ResponsiveImage value={ data.field_profile_photo.value }/> :
              <img src={ ProfilePic } alt={ 'Profielfoto' }/> }
          </div>

          <div className={ 'profile-detail__actions' }>
            <ProfileDetailActions profile={ data }
                                  isOwnProfile={ isOwnProfile }/>
          </div>

          <div className={ 'profile-detail__user' }>
            <h2 className={ 'profile-detail__user-title' }>{ data.title.value }</h2>

            <div className={ 'profile-detail__user-info' }>
              <Labels items={ infoLabels } variant={ 'light' }/>
            </div>

            <div className={ 'profile-detail__user-location' }>
              { data.field_profile_city.value }
            </div>
          </div>
        </div>

        <div className={ 'profile-detail__body' }>
          <div className={ 'profile-detail__content' }>
            <div className={ 'profile-detail__content-row' }>
              <h3>Interesses</h3>
              { interestLabels.length > 0 ? <Labels items={ interestLabels } variant={ 'dark' }/> :
                <Trans text={ 'Er zijn nog geen interesses opgegeven.' }/> }
            </div>

            <div className={ 'profile-detail__content-row' }>
              <h3>Over mij</h3>
              {
                data.field_profile_description?.display
                  ?
                  <HTMLContainer>
                    { data.field_profile_description.display }
                  </HTMLContainer>
                  :
                  <Trans text={ 'Nog niet ingevuld.' }/>
              }
            </div>
          </div>

          <div className={ 'profile-detail__links' }>
            <h3>Profiel</h3>
            <ProfileDetailActions profile={ data } isOwnProfile={ isOwnProfile }/>
          </div>
        </div>
      </div>
    </>
  )
}

export default ProfileDetail;
